module.exports = __webpack_public_path__ + "img/thedonato.4eb8226b.png";